// extracted by mini-css-extract-plugin
export default {"wrapper":"id","form":"jd","checkbox":"kd","successWrapper":"ld","success":"md","successText":"nd","circle":"od","footnote":"pd","required":"qd"};